import { useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router'

export function useSmartBack(fallbackPath: string = '/') {
  const navigate = useNavigate()
  const location = useLocation()

  const goBack = useCallback(() => {
    const hasHistory = location.key !== 'default'

    if (hasHistory) {
      navigate(-1)
    } else {
      navigate(fallbackPath, { replace: true })
    }
  }, [location.key, navigate, fallbackPath])

  return { goBack }
}
